import { Select } from 'ComponentLibrary'
import { OrderFilterContainer } from '../sharedStyles'
import invariant from 'tiny-invariant'

type OrderPortfolioFilterProps<T> = {
    setPortfolio: (portfolio: T | undefined) => void
    portfolio?: T
    portfolios: T[]
    inputLabel?: string
}

export function OrderPortfolioFilter<T extends { uuid: string; title: string }>({
    setPortfolio,
    portfolio,
    portfolios,
    inputLabel = 'Portfolio',
}: OrderPortfolioFilterProps<T>) {
    const portfolioOptions = portfolios.map((portfolio) => ({
        value: portfolio.uuid,
        label: portfolio.title,
    }))

    const findPortfolio = (portfolioId: string) => {
        const item = portfolios.find((portfolio) => portfolio.uuid === portfolioId)
        invariant(item !== undefined, 'The portfolio option must be present')
        return item
    }

    return (
        <OrderFilterContainer>
            <Select
                value={portfolio?.uuid || ''}
                onChange={(event) => {
                    const newPortfolioId = event.target.value
                    invariant(newPortfolioId !== undefined && newPortfolioId !== null, 'The portfolio option must be set')
                    const newPortfolio = findPortfolio(newPortfolioId)
                    setPortfolio(newPortfolio)
                }}
                options={portfolioOptions}
                clear={() => setPortfolio(undefined)}
                inputLabel={inputLabel}
                size="small"
                sortedBy="alphabetical"
                fullWidth
            />
        </OrderFilterContainer>
    )
}
